<template>
    <div>
        <table class="bm-table" style="margin: 0px;">
            <tr class="table-header">
                <td colspan="2" style="text-align: center">Raac Selection</td>
            </tr>
            <tr style="display: none;">
                <td class="bm-table-name">Type</td>
                <td class="bm-table-ope">
                    <el-select
                            v-model="value_raac_type"
                            placeholder="Select item"
                    >
                        <el-option
                                v-for="item in options_raac_type"
                                :key="item.value"
                                :label="item.label"
                                :value="item.value"
                        ></el-option>
                    </el-select>
                </td>
            </tr>
            <tr>
                <td class="bm-table-name">Scheme</td>
                <td class="bm-table-ope">
                    <el-select
                            filterable
                            v-model="value_raac"
                            placeholder="Select item"
                    >
                        <el-option
                                v-for="item in options_raac"
                                :key="item.value"
                                :label="item.label"
                                :value="item.value"
                        ></el-option>
                    </el-select>
                </td>
            </tr>
            <tr v-show="!is_custom_show">
                <td class="bm-table-name" style="widht: 60px !important;">Cluster</td>
                <td class="bm-table-ope">
                    <el-select
                            filterable
                            v-model="value_raac_scheme"
                            placeholder="Select item"
                    >
                        <el-option
                                v-for="item in options_raac_scheme"
                                :key="item.value"
                                :label="item.label"
                                :value="item.value"
                                :id="item.id"
                        ></el-option>
                    </el-select>
                </td>
            </tr>
            <tr v-show="is_custom_show">
                <td class="bm-table-name" style="width: 50px !important;">Cluster</td>
                <td class="bm-table-ope bm-btn-custom">
                        <el-input placeholder="Input custom raac" v-model="custom_raac" class="input-with-select" @input="getCustom">
                            <!--<el-button slot="append" icon="el-icon-search" @click="getClickCustom"></el-button>-->
                        </el-input>
                </td>
            </tr>
        </table>
        <table class="bm-table" style="margin-bottom: 0px">
            <tr class="table-header">
                <td colspan="2" style="text-align: center">Raac Visual</td>
            </tr>
        </table>
        <el-scrollbar style="height: 100px" class="baimo-scrollbar">
            <!--<raac-bar :num="-1" :seq="'Total'" :seqWidth="seqWidth"></raac-bar>-->
            <raac-bar v-for="(item, i) in raac_scheme" :num="i+1" :seq="item" :key="i"></raac-bar>
        </el-scrollbar>
    </div>
</template>

<script>
    import RaacBar from "../raacview/RaacBar"
    import axios from "axios";
    import global_ from "../units/Global";
    // import {mapGetters} from 'vuex';

    export default {
        name: "RaacSelector",
        data() {
            return {
                website: global_.website,
                current_raac_id: '85_2_1',
                custom_raac:'',
                options_raac_type: [{
                    value: 'Reduced Method',
                    label: 'Reduced Method'
                }, {
                    value: 'Raac Type',
                    label: 'Raac Type'
                },
                {
                    value: 'Paper',
                    label: 'Paper'
                }, {
                    value: 'Author',
                    label: 'Author'
                }],
                value_raac_type: 'Reduced Method',
                options_raac: [
                    {value: 'Custom', label: 'Custom'},
                    {value: 'Artificial Immune System(AIS)', label: 'Artificial Immune System(AIS)'},
                    {value: 'BLOSUM40 matrix', label: 'BLOSUM40 matrix'},
                    {value: 'BLOSUM50 matrix', label: 'BLOSUM50 matrix'},
                    {value: 'BLOSUM62 & Heuristic Monte Carlo (MC)', label: 'BLOSUM62 & Heuristic Monte Carlo (MC)'},
                    {value: 'Boltzmann relation or iteration', label: 'Boltzmann relation or iteration'},
                    {value: 'Charge', label: 'Charge'},
                    {value: 'Chemistry properties', label: 'Chemistry properties'},
                    {value: 'Chemistry space', label: 'Chemistry space'},
                    {value: 'Clustering analysis', label: 'Clustering analysis'},
                    {value: 'Contact potential', label: 'Contact potential'},
                    {value: 'Distance matrix', label: 'Distance matrix'},
                    {value: 'Dynamic clustering', label: 'Dynamic clustering'},
                    {value: 'Dynamic Programming Alignments', label: 'Dynamic Programming Alignments'},
                    {value: 'Essential amino acid', label: 'Essential amino acid'},
                    {value: 'Euclidean distance', label: 'Euclidean distance'},
                    {value: 'Extended Compact Genetic Algorithm(ECGA)', label: 'Extended Compact Genetic Algorithm(ECGA)'},
                    {value: 'Fuzzy clustering technique and matrices', label: 'Fuzzy clustering technique and matrices'},
                    {value: 'Genetic algorithm', label: 'Genetic algorithm'},
                    {value: 'GONNET matrix', label: 'GONNET matrix'},
                    {value: 'Grantham Distance Matrix', label: 'Grantham Distance Matrix'},
                    {value: 'Hierarchical clustering', label: 'Hierarchical clustering'},
                    {value: 'hydrophobic and polar (HP) model', label: 'hydrophobic and polar (HP) model'},
                    {value: 'Hydrophobicity', label: 'Hydrophobicity'},
                    {value: 'Hydroxylic', label: 'Hydroxylic'},
                    {value: 'Information theory', label: 'nformation theory'},
                    {value: 'JTT rate matrix', label: 'JTT rate matrix'},
                    {value: 'K-means', label: 'K-means'},
                    {value: 'Maximized mutual information', label: 'Maximized mutual information'},
                    {value: 'Miyazawa and Jernigan (MJ) matrix', label: 'Miyazawa and Jernigan (MJ) matrix'},
                    {value: 'Miyazawa Jernigan (MJ) & BLOSUM50 & BLOSUM62 matrix', label: 'Miyazawa Jernigan (MJ) & BLOSUM50 & BLOSUM62 matrix'},
                    {value: 'Miyazawa Jernigan (MJ) matrix', label: 'Miyazawa Jernigan (MJ) matrix'},
                    {value: 'Miyazawa Jernigan (MJ) matrix and contact potential', label: 'Miyazawa Jernigan (MJ) matrix and contact potential'},
                    {value: 'Molecular mass', label: 'Molecular mass'},
                    {value: 'Normalized van der Waals volume', label: 'Normalized van der Waals volume'},
                    {value: 'Particle Swarm Optimization (PSO)', label: 'Particle Swarm Optimization (PSO)'},
                    {value: 'Physical-chemical property', label: 'Physical-chemical property'},
                    {value: 'Point Accepted Mutation(PAM) matrix', label: 'Point Accepted Mutation(PAM) matrix'},
                    {value: 'Polarity', label: 'Polarity'},
                    {value: 'Polarizability', label: 'Polarizability'},
                    {value: 'Protein blocks', label: 'Protein blocks'},
                    {value: 'Secondary Structure', label: 'Secondary Structure'},
                    {value: 'Sequence alignments', label: 'Sequence alignments'},
                    {value: 'Solvent Accessibility', label: 'Solvent Accessibility'},
                    {value: 'Structure alignments', label: 'Structure alignments'},
                    {value: 'Structure-Derived Matrix', label: 'Structure-Derived Matrix'},
                    {value: 'Sulfuric', label: 'Sulfuric'},
                    {value: 'The maximum information gain', label: 'The maximum information gain'},
                    {value: 'Unweighted Pair-Group Method', label: 'Unweighted Pair-Group Method'},
                    {value: 'Unweighted Pair-Group Method with Arithmetic (UPGMA)', label: 'Unweighted Pair-Group Method with Arithmetic (UPGMA)'},
                    {value: 'Unweighted variable group', label: 'Unweighted variable group'},
                    {value: 'Variance maximization', label: 'Variance maximization'},
                    {value: 'Whelan and Goldman', label: 'Whelan and Goldman'},
                    {value: 'Abundance in proteins', label: 'Abundance in proteins'},
                    {value: 'Acid', label: 'Acid'},
                    {value: 'Aliphatic', label: 'Aliphatic'},
                    {value: 'Alkaline', label: 'Alkaline'},
                    {value: 'Amide', label: 'Amide'},
                    {value: 'Aromatic', label: 'Aromatic'},],
                value_raac: 'Charge',
                options_raac_scheme:[
                    {
                        value: 'KR-ANCQGHILMFPQSTVW-DE',
                        label: 'KR-ANCQGHILMFPQSTVW-DE'
                    },
                    {
                        value: 'HKR-ANCQGILMFPSTWYV-DE',
                        label: 'HKR-ANCQGILMFPSTWYV-DE'
                    }
                ],
                value_raac_scheme: "KR-ANCQGHILMFPQSTVW-DE",
                raac_type_map:{
                    'Reduced Method': 'method',
                    'Raac Type': 'raac_id',
                    'Description': 'descriptions',
                    'Paper': 'paper',
                    'Author': 'author',
                },
                raac_scheme:['KR','ANCQGHILMFPQSTVW','DE'],
                color_map: {
                    'A': '#D5D5D5',
                    'R': '#f7d794',
                    'N': '#778beb',
                    'D': '#546de5',
                    'C': '#cf6a87',
                    'Q': '#f19066',
                    'E': '#e77f67',
                    'G': '#f5cd79',
                    'H': '#e15f41',
                    'I': '#c44569',
                    'L': '#786fa6',
                    'K': '#f8a5c2',
                    'M': '#63cdda',
                    'F': '#ea8685',
                    'P': '#596275',
                    'S': '#574b90',
                    'T': '#f78fb3',
                    'W': '#3dc1d3',
                    'Y': '#e66767',
                    'V': '#303952',
                },
                seqWidth: 310,
                current_raac: "",
                is_custom_show: false,
            }
        },
        components: {
            RaacBar,
        },
        computed: {

        },
        watch: {
            value_raac_type(val){
                this.getRaacSearch(val);
            },
            value_raac(val){
                let key = this.raac_type_map[this.value_raac_type];
                this.getRaac(key, val);
            },
            value_raac_scheme(val){
                this.$emit('raac_scheme', val);
                this.raac_scheme = this.value_raac_scheme.split("-");
                let current_raac_color = [];
                let current_raac_shape = [];
                let current_raac_visible = [];
                this.raac_scheme.forEach((seq, i)=>{
                    let first = seq.substr(0, 1);
                    current_raac_color[i] = this.color_map[first];
                    current_raac_shape[i] = 'cartoon';
                    current_raac_visible[i] = true;
                });
                // console.log("this.raac_scheme", this.raac_scheme);
                this.changeRaac(val);
                this.$store.commit('raacColorMutation', current_raac_color);
                this.$store.commit('raacSchemeMutation', this.raac_scheme);
                this.$store.commit('raacShapeeMutation', current_raac_shape);
                this.$store.commit('raacVisibleMutation', current_raac_visible);
                // console.log("this.$store.state.raac_scheme", this.$store.state.raac_scheme)
            },

        },
        methods: {
            getCustom(val) {
                let israac = /^[a-zA-Z-]+$/.test(val);
                let is_right_raac = /^[DEGYCAFHIKLMNPQRSTVW-]*$/.test(val);

                if(val === "") {
                    this.custom_raac = ""
                }
                if (israac){
                    let raac_num = val.replace(/-/g, "").length;
                    if (raac_num === 20 && val !== ""){
                        this.custom_raac = val.replace(/,/g, "-").replace(/，/g, "-").replace(/·/g, "-").replace(/`/g, "-").replace(/\./g, "-").toUpperCase();
                        this.current_raac = this.custom_raac;
                        if (!this.checkRepeat(this.current_raac.replace(/-/g, ""))) {
                            this.$message({
                                message: `Repeated amino acid abbreviations.`,
                                type: 'warning'
                            });
                        }else if (!is_right_raac){
                            this.$message({
                                message: `Incorrect amino acid abbreviations.`,
                                type: 'warning'
                            });
                        }else{
                            this.$message({
                                message: `Complete the input of 20 amino acid abbreviations.`,
                                type: 'success'
                            });
                            this.value_raac_scheme = this.current_raac;
                            // console.log("this.value_raac_scheme", this.value_raac_scheme)
                        }
                    }else if (raac_num < 20 && val !== ""){
                        this.custom_raac = val.replace(/,/g, "-").replace(/，/g, "-").replace(/·/g, "-").replace(/`/g, "-").replace(/\./g, "-").toUpperCase();
                    }else{
                        this.custom_raac = this.current_raac
                        // this.$message({
                        //     message: `Complete the input of 20 amino acid abbreviations.`,
                        //     type: 'success'
                        // });
                    }
                }else{
                    this.$message({
                        message: `Non-amino acid abbreviations. Please check: ${val}`,
                        type: 'warning'
                    });
                }
            },
            checkRepeat(str) {
                 return !/(.).*\1/i.test(str);
            },
            getClickCustom(val){
                let raac_num = val.replace(/-/g, "").length;
                if (raac_num === 20 && val !== ""){
                    this.custom_raac = val.replace(/,/g, "-").replace(/，/g, "-").replace(/·/g, "-").replace(/`/g, "-").replace(/\./g, "-").toUpperCase();
                }else{
                    this.$message({
                        message: `Repeated or Incorrect amino acid abbreviations.`,
                        type: 'warning'
                    });
                }
            },
            changeRaac(e) {
                if (this.is_custom_show){
                    this.$store.commit('currentRaacIdMutation', 'custom');
                }else{
                    let obj = {};
                    obj = this.options_raac_scheme.find((item)=>{
                        // console.log(item);
                        return item.label === e;//筛选出匹配数据
                    });
                    this.current_raac_id = obj.id;
                    this.$store.commit('currentRaacIdMutation', this.current_raac_id);
                }
            },
            getRaac(key, val){
                // console.log("getRaac", key, val)
                if (val === "Custom"){
                    this.is_custom_show = true;
                    this.raac_scheme = "";
                }else{
                    this.is_custom_show = false;
                    let url = `${this.website}/api/raac_scheme_search/${key}/${val}/`;
                    // console.log(url);
                    axios.get(url).then((res) => {
                        this.loading = false;
                        this.options_raac_scheme = res.data.results.map((item, i) => {
                            let cluster = item['cluster'];
                            let raac_id = item['raac_id'];
                            if(i === 0){
                                this.value_raac_scheme = cluster;
                                this.raac_scheme = cluster.split("-");
                            }
                            return {
                                value: `${cluster}`,
                                label: `${cluster}`,
                                id: `${raac_id}`,
                            };
                        });
                        // this.options_raac_scheme.push({
                        //     value: 'Custom',
                        //     label: 'Custom',
                        //     id: 'Custom',
                        // })
                    });
                }
            },
            getRaacSearch(val) {
                let key = this.raac_type_map[val];
                let url = `${this.website}/api/raac_type_search/${val}/`;
                // console.log(url);
                axios.get(url).then((res) => {
                        this.loading = false;
                        this.options_raac = res.data.results.map((item) => {
                            // let raac_id = item['raac_id'];
                            let method = item[key];
                            // console.log(method, typeof(method),  method != null);
                            if (key === "paper"){
                                method = this.ellipsis(method, 100);
                            }
                            return {
                                value: `${method}`,
                                label: `${method}`,
                                id: `${method}`,
                            };
                            // if (method != undefined && method != "" && method != null){
                            //
                            // }

                            // switch (this.value_raac_type) {
                            //     case "Reduced Method":
                            //
                            // }
                        });
                        switch (key) {
                            case "method":
                                this.value_raac = 'Aromatic';
                                break;
                            case "raac_id":
                                this.value_raac = '1_2_1';
                                break;
                            case "descriptions":
                                this.value_raac = 'Aromatic';
                                break;
                            case "paper":
                                this.value_raac = 'Simplified amino acid alphabets for protein fold recognition and implications for folding';
                                break;
                            case "author":
                                this.value_raac = '1';
                                break;
                        }
                    }
                );
            },
            ellipsis(value, max) {
                if (!value) return "";
                if (value.length > max) {
                    //先去掉text里面带来的 &nbsp; 然后再去空格
                    return (
                        value
                            // .replace(/&nbsp;/g, "")
                            // .replace("<br>", "")
                            // .replace(/\s/g, "")
                            .slice(0, max) + "..."
                    );
                }
                return value;
            }
        }
    }
</script>

<style >
    .el-input-group__append, .el-input-group__prepend {
        background-color: #F5F7FA;
        color: #909399;
        vertical-align: middle;
        display: table-cell;
        position: relative;
        border: 0px solid #DCDFE6 !important;
        border-radius: 0px;
        padding: 0 20px;
        width: 1px;
        white-space: nowrap;
    }

    table {
        border: 1px solid #ccc;
        color: #4b6584;
        border-top: none;
        margin-bottom: 20px;
    }

    .bm-table td {
        border: 1px solid #ccc;
        padding: 5px 10px 5px 0;
    }

    .bm-table tr {
        border: 1px solid #ccc;
    }

    .bm-table-name {
        width: 60px;
        text-align: right;
        background: #dfe4ea ;
    }

    .bm-table-ope {
        width: 220px;
        padding: 0px !important;
    }

    .hr-header {
        /*border-bottom: 1px solid #a4b0be;*/
        padding-bottom: 0px;
    }

    .hr-header p {
        margin-bottom: 0px;
        background: #ffffff;
        width: 331px;
        font-size: 14px;
        padding: 3px 10px 3px 10px;
        border-top-left-radius: 5px;
        border-top-right-radius: 5px;
        border: 1px solid #a4b0be;
        border-bottom: none;
        text-align: center;
    }

    /deep/ .el-input__inner {
        height: 30px;
        border: none !important;
        background: transparent !important;
    }

    /deep/ .el-select-dropdown__list {
        margin-bottom: 15px !important;
        padding: 0px !important;
    }

    /deep/ .el-input__icon {
        line-height: 30px;
    }

    /deep/ .el-select-dropdown__item {
        font-size: 14px;
        padding: 0 10px !important;
        position: relative;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        color: #606266;
        height: 34px;
        line-height: 34px;
        box-sizing: border-box;
        cursor: pointer;
    }

    /deep/ .el-dropdown-menu__item {
        list-style: none;
        line-height: 22px !important;
        padding: 0 8px;
        margin: 0;
        font-size: 4px;
        color: #606266;
        cursor: pointer;
        outline: 0;
    }

</style>
